/**
 * Shared Enums
 *
 * Common enum schemas used across the platform.
 * Re-exported from schemas for convenience.
 */

// Re-export enums from schemas (they're defined there for co-location with related types)
export { UserRoleSchema, type UserRole, NavigationTypeSchema, type NavigationType } from '../schemas'

// Re-export entity enums
export { SchoolStatusSchema, type SchoolStatus } from '../schemas/entities/school'

export {
  SYNC_WINDOW_VALUES,
  SYNC_WINDOW_LABELS,
  SyncWindowSchema,
  type SyncWindow,
  SyncPrioritySchema,
  type SyncPriority,
  SyncJobStatusSchema,
  type SyncJobStatus
} from '../schemas/entities/sync'
